import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import NavigationBar from './components/NavigationBar';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import SolutionsSection from './components/SolutionsSection';
import TechnologySection from './components/TechnologySection';
import PemsSection from './components/PemsSection';
import ProductsSection from './components/ProductsSection';
import SustainabilitySection from './components/SustainabilitySection';
import WorkflowSection from './components/WorkflowSection';
import FinancialSection from './components/FinancialSection';
import PartnersSection from './components/PartnersSection';
import ProjectsSection from './components/ProjectsSection';
import ClientsSection from './components/ClientsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <NavigationBar />
        <HeroSection />
        <StatsSection />
        <SolutionsSection />
        <TechnologySection />
        <PemsSection />
        <ClientsSection />
        <WorkflowSection />
        <FinancialSection />
        <ProjectsSection />
        <ProductsSection />
        <PartnersSection />
        <SustainabilitySection />
        <ContactSection />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
